import { Tooltip } from '@odo/shared-ui';
import { useNow } from '../../../hooks/useNow';
import { formatDateTime } from '../../../utils/dates';
import { TimeCell } from '../../shared/TimeCell';
import { waitingTier, type WaitingInbox } from './waitingTier';

const CLOCK_TICK_MS = 60_000;

interface WaitingCellProps {
    oldestAt: string | null;
    latestAt: string | null;
    inbox: WaitingInbox;
}

function waitingTooltip(oldestAt: string | null, latestAt: string | null): string {
    const oldest = formatDateTime(oldestAt);
    const latest = formatDateTime(latestAt);
    return [oldest && `Oldest open: ${oldest}`, latest && `Latest: ${latest}`]
        .filter(Boolean)
        .join('\n');
}

export function WaitingCell({ oldestAt, latestAt, inbox }: WaitingCellProps) {
    const now = useNow(CLOCK_TICK_MS);
    const oldestMs = oldestAt ? new Date(oldestAt).getTime() : Number.NaN;
    return (
        <Tooltip content={waitingTooltip(oldestAt, latestAt)}>
            <div>
                <TimeCell iso={oldestAt} tier={waitingTier(now - oldestMs, inbox)} now={now} />
            </div>
        </Tooltip>
    );
}
